import { ReactComponent as ImportIcon } from '@/assets/icons/import_icon.svg'
import { ReactComponent as ChattyIcon } from '@/assets/img/chatty-ai-icon.svg'
import { ReactComponent as RespondSpokenIcon } from '@/assets/icons/question_respond_spoken_icon.svg'
import { ReactComponent as RespondWriteIcon } from '@/assets/icons/question_respond_write_icon.svg'
import { ReactComponent as RepeatIcon } from '@/assets/icons/question_repeat_icon.svg'
import { ReactComponent as MCIcon } from '@/assets/icons/question_mc_icon.svg'
import { ReactComponent as MediaIcon } from '@/assets/icons/question_media_icon.svg'
import { ReactComponent as ShortAnswerIcon } from '@/assets/icons/question_short_answer_icon.svg'

export const CARD_ICONS = {
  MediaPage: MediaIcon,
  RepeatCard: RepeatIcon,
  RespondCardSpoken: RespondSpokenIcon,
  RespondCardWritten: RespondWriteIcon,
  ShortAnswer: ShortAnswerIcon,
  MCCard: MCIcon,
  Import: ImportIcon,
  Chatty: ChattyIcon,
}

export const CARD_ICONS_BG = {
  RepeatCard: '#ECFDFF',
  RespondCardSpoken: '#E3F2FD',
  RespondCardWritten: '#E6F4D7',
  ShortAnswer: '#E6F4D7',
  MCCard: '#EBE9FE',
  Import: '#FFE6D5',
  Chatty: '#f99fdd',
  MediaPage: '#FFFAEB',
}
